import { render, staticRenderFns } from "./Hills.vue?vue&type=template&id=549ba90f&"
import script from "./Hills.vue?vue&type=script&lang=js&"
export * from "./Hills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  "51c79570"
  
)

export default component.exports